<p>{{ 'aumico_reports_fcp_closing_process_checklist_mark_all_as_done_text' | i18next }}</p>
<div class="dont-show-again-container">
    <span class="custom-checkbox" hamCheckbox (change)="onDontAskAgainChange($event)"
        >{{ 'aumico_reports_fcp_closing_process_checklist_mark_all_as_dont_show_again' | i18next }}
    </span>
</div>
